import { LayoutHOC } from 'base/ui/layout/layout';

import { MarketingCampaignRoutes } from './routes';
import createPresentReport from './presentReport';
import createTHTTKHReport from './THTTKH';

export const createMarketingCampaignPage = (layoutHOC: LayoutHOC) => {
  // BÁO CÁO DANH SÁCH TÀI TRỢ-QUÀ TẶNG KHÁCH HÀNG
  const PresentReport = createPresentReport();
  const BCTHTTKH = createTHTTKHReport();
  const MarketingCampaignPage = layoutHOC(MarketingCampaignRoutes);

  return () => <MarketingCampaignPage PresentReport={PresentReport} BCTHTTKH={BCTHTTKH} />;
};
